import { createChatBotMessage } from 'react-chatbot-kit';
import AnswerWidget from './AnwserWidget';
import QuestionOptions from './QuestionOptions';
import faqData from './questions';

const botName = 'Vinga Bot';

const config = {
  initialMessages: [
    createChatBotMessage("Hi! How can I help you?", {
      widget: "faqOptions",
    }),
  ],
  widgets: [
    {
      widgetName: "faqOptions",
      widgetFunc: (props) => <QuestionOptions {...props} faqData={faqData} />,
    },
    {
      widgetName: "showAnswer",
      widgetFunc: (props) => <AnswerWidget {...props} />,
    },
  ],
  botName : botName,
  customStyles : {
    botMessageBox : {
      backgroundColor : '#376B7E',
    },
    chatButton : {
      backgroundColor : '#5ccc9d'
    }
  }
};

export default config;